import React from 'react';
import { Highlight } from '../../../ui';

const exampleImageSource =
	'https://cdn.images.express.co.uk/img/dynamic/24/590x/Tesla-Roadster-0-60mph-881815.jpg';

export const Highlights = () => (
	<>
		<h2 id="highlights">Highlights</h2>

		<h3>Highlight, with inline link</h3>
		<Highlight
			title="Car Rental Tip"
			orientation={['horizontal', { mobileXL: 'vertical' }]}
			imageSource={exampleImageSource}
			imageAlt="Some image"
			linkTitle="Read more"
			linkHref="https://www.google.com"
		>
			<p>
				Rental car companies are no longer operating on Rental Car Road. Thrifty
				is located off site and all other companies are located in the
				Consolidated Rental Car Facility.
			</p>
		</Highlight>
		<br />
		<br />
		<h3>Highlight, elevated, without link, image right</h3>
		<Highlight
			elevated
			title="Car Rental Tip"
			orientation={['horizontal', { mobileXL: 'vertical' }]}
			imagePosition={['last', { mobileXL: 'first' }]}
			imageSource={exampleImageSource}
			imageAlt="Some image"
		>
			<p>
				Rental car companies are no longer operating on Rental Car Road. Thrifty
				is located off site and all other companies are located in the
				Consolidated Rental Car Facility.
			</p>
		</Highlight>
		<br />
		<br />
		<h3>Highlight, elevated, with link, and background color</h3>
		<Highlight
			elevated
			fullyClickable
			withBackgroundColor
			title="Car Rental Tip"
			orientation={['horizontal', { mobileXL: 'vertical' }]}
			imageSource={exampleImageSource}
			imageAlt="Some image"
			linkTitle="Read more"
			linkHref="https://www.google.com"
		>
			<p>
				Rental car companies are no longer operating on Rental Car Road. Thrifty
				is located off site and all other companies are located in the
				Consolidated Rental Car Facility.
			</p>
		</Highlight>
	</>
);
